<template>
  <FormBase @submit="save">
    <template #title>Change Your Password</template>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">Current Password</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.current_password"
          type="password"
          class="form-control "
          :class="{ 'is-invalid': hasError('current_password') }"
          @input="clearError('current_password')"
        />
        <div v-if="hasError('current_password')" class="invalid-feedback">
          {{ getError("current_password") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">New Password</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.new_password"
          type="password"
          class="form-control "
          :class="{ 'is-invalid': hasError('new_password') }"
          @input="clearError('new_password')"
        />
        <div v-if="hasError('new_password')" class="invalid-feedback">
          {{ getError("new_password") }}
        </div>
      </div>
    </div>

    <div class="form-group form-group-last row required">
      <label class="col-xl-3 col-lg-3 col-form-label">Confirm Password</label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.new_password_confirmation"
          type="password"
          class="form-control "
          :class="{ 'is-invalid': hasError('new_password_confirmation') }"
          @input="clearError('new_password_confirmation')"
        />
        <div
          v-if="hasError('new_password_confirmation')"
          class="invalid-feedback"
        >
          {{ getError("new_password_confirmation") }}
        </div>
      </div>
    </div>
  </FormBase>
</template>

<script>
import { mapActions } from "vuex";
import FormBase from "./-FormBase.vue";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";

export default {
  name: "ChangePassword",
  components: {
    FormBase,
  },

  mixins: [ValidationErrorsMixin],

  data() {
    return {
      form: {
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      busy: false,
    };
  },

  methods: {
    ...mapActions({
      changePassword: "auth/changePassword",
    }),

    save() {
      if (this.busy) {
        return;
      }

      this.busy = true;

      this.changePassword(this.form)
        .then(() => {
          this.form = {
            current_password: "",
            new_password: "",
            new_password_confirmation: "",
          };

          this.$swal({
            icon: "success",
            title: "Upload successful!",
            text: "Your password updated successfully.",
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
